module.exports = __webpack_public_path__ + "static/media/Fluency Heuristic - sigmund-yXiLaaYwg_E-unsplash.5a8acbbe.jpg";